import FormAccepted from './formAccepted';

export default FormAccepted;
